<div id="top_menu_bar">
    <div id="top_menu_bar_actions" class="container" [ngClass]="{'round-trip': INDRA_showDate(), 'multicity' : !this.INDRA_showDate()}">
        <ng-container *ngFor="let item of menuItems">
            <div [id]="item.id" class="menu_bar_btn_container" [ngClass]="INDRA_buttonStyle(item.id)">
                <span class="left-line"></span>
                <button (click)="INDRA_handleActionBtn(item.id)" [disabled]="INDRA_lockNextBtns(item.id)">
                    <div class="step-box">
                        <div class="circle_box">
                            <span class="dot">{{INDRA_showOrder(item.id)}}</span>
                        </div>
                        <label
                            skeletonLoader
                            [translationKey]="item.translationKey"
                            class="menu_bar_label"
                        >
                            {{item.translationKey | ibeadmin | async}}
                        </label>
                    </div>
                </button>
                <span class="right-line"></span>
            </div>
        </ng-container>
    </div>
    <div *ngIf="this.current_page == 'dates'">
        <div class="context__steps">
            <div class="full-width">
                <ng-content select=".steps" aria-label="List with steps" tabindex=0></ng-content>
            </div>
        </div>
        <ng-content select=".extra"></ng-content>
    </div>
</div>
